import PropTypes from 'prop-types';
import React from 'react';
import {Chip} from '@mui/material';
import {theme} from '@account/styles';

const StatusChip = ({
  statusColor,
  disableBorder,
  variant = 'outlined',
  size = 'small',
  ...props
}) => {
  const bgColor = theme.palette.grey[200];

  return (
    <Chip
      data-qe="status-chip"
      variant={variant}
      size={size}
      {...props}
      sx={{
        padding: theme.spacing(0.5, 0),
        textTransform: 'capitalize',
        backgroundColor: statusColor
          ? theme.palette[statusColor].light
          : bgColor,
        borderStyle: disableBorder ? 'none' : 'solid',
        borderColor: statusColor
          ? theme.palette[statusColor].main
          : 'rgba(0, 0, 0, 0.23)',
        '& .MuiChip-label': {
          color: statusColor
            ? theme.palette.getContrastText(theme.palette[statusColor].main)
            : theme.palette.getContrastText(bgColor),
        },
        '&.MuiChip-outlined .MuiChip-label': {
          color: statusColor
            ? theme.palette[statusColor].dark
            : theme.palette.getContrastText(bgColor),
        },
        '& .MuiChip-icon': {
          color: 'inherit',
          marginRight: props.label ? theme.spacing(-0.5) : theme.spacing(0.5),
        },
      }}
    />
  );
};

StatusChip.propTypes = {
  disableBorder: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.string,
  statusColor: PropTypes.string,
  variant: PropTypes.string,
};

export default StatusChip;
